export const assertNever = (_v: never, error: Error | (() => Error) = () => new Error('Unexpected case reached')): never => {
  const err = typeof error === 'function' ? error() : error
  throw err
}

export const assertNeverSilent = (_v: never): void => {
  return undefined
}
